import { StackShim as Stack } from '@fluentui/react-migration-v8-v9';
import { Select, FluentProvider, webLightTheme } from '@fluentui/react-components';
import React from 'react';
import { IMilestoneConfigAssigneeOption } from './ProcessConfigTypes';
import IDropdownOption from '../../../utils/types/IDropdownOption';

interface IMilestoneConfigEditFormProps {
  milestones: IMilestoneConfigAssigneeOption[];
  updateAssignee: (newValue: IDropdownOption, milestoneConfigId: number) => void;
}

const MilestoneConfigEditForm = ({
  milestones,
  updateAssignee,
}: IMilestoneConfigEditFormProps): JSX.Element => {
  return (
    <>
      <Stack tokens={{ childrenGap: 5 }}>
        {milestones.map((milestone: IMilestoneConfigAssigneeOption) => {
          const disabled = milestone.assigneeOptions.length === 0;
          const selectedOption = milestone.assigneeOptions.find(
            (option) => option.key === milestone.assigneeId,
          );

          return (
            <FluentProvider theme={webLightTheme} key={milestone.id}>
              <label htmlFor={`milestone-${milestone.id}`}>{milestone.milestoneTemplateName}</label>
              <Select
                id={`milestone-${milestone.id}`}
                defaultValue={selectedOption?.key?.toString() || ''}
                disabled={disabled}
                onChange={(event, data) => {
                  const selected = milestone.assigneeOptions.find(
                    (option) => option.key.toString() === data.value,
                  );
                  if (selected) {
                    updateAssignee(selected, milestone.id);
                  }
                }}
              >
                {!disabled && (
                  <option value="" disabled>
                    Select an assignee
                  </option>
                )}
                {milestone.assigneeOptions.map((option) => (
                  <option key={option.key} value={option.key}>
                    {option.text}
                  </option>
                ))}
              </Select>
            </FluentProvider>
          );
        })}
      </Stack>
    </>
  );
};

export default MilestoneConfigEditForm;
